const partyArea = {
   endPos:1,
   startTime: Date.now(),
   switchInterval:10000,
   init() {
    this.domEls = this.getEls();
    this.domLen = this.domEls.length;
    this.startSwitch();
   },
   getEls() {
       return [].slice.call(document.querySelectorAll('.party-container a'));
   },
   startSwitch() {
       window.requestAnimationFrame(this.render.bind(this))
   },
   render(time) {
         const curTime = Date.now();
         if (Math.abs(curTime - this.startTime) > this.switchInterval) {
             this.startTime = curTime;
            this.domEls[(this.endPos)%this.domLen].style.display = 'none';
            this.domEls[(this.endPos-1)%this.domLen].style.display = 'none';
            this.domEls[(this.endPos+1)%this.domLen].style.display = 'block';
            this.domEls[(this.endPos+2)%this.domLen].style.display = 'block';
            this.endPos+=2;
         }
        window.requestAnimationFrame(this.render.bind(this))
   }
}
export default partyArea


// WEBPACK FOOTER //
// ./src/JS/party/index.js